import _ from 'lodash';
import globalStore from '@/stores';
import { ACCOUNT_TYPE } from '@/constants/Constants';
import { LoginType } from '@/model/user';

/**
 * @description 是否有权限
 * @param  {} purview
 * @param  {} type
 * @return {Boolean}
 */
export const hasPurview = (_purview, type = 'allOf') => {
  const purview = _.isArray(_purview) ? _purview : [_purview];
  const { account = {} } = globalStore;
  const { privilege = [] } = account;
  const intersectionLen = _.intersection(privilege, purview).length;
  if (type === 'allOf') {
    return intersectionLen === purview.length;
  }
  if (type === 'oneOf') {
    return intersectionLen > 0;
  }
  return false;
};

/**
 * @description 是否有销售权限
 * @param  {} purview
 * @param  {} type
 * @return {Boolean}
 */
export const hasSalePurview = (_purview, permType = 'user', type = 'allOf') => {
  const purview = _.isArray(_purview) ? _purview : [_purview];
  const privilege = globalStore.account?.saleStatus?.[`${permType}Permissions`] || [];
  const intersectionLen = _.intersection(privilege, purview).length;
  if (type === 'allOf') {
    return intersectionLen === purview.length;
  }
  if (type === 'oneOf') {
    return intersectionLen > 0;
  }
  return false;
};

/**
 * @description 是否有灰度开关
 * @param  {} feature_flag
 * @param  {} _agency_uid
 * @return {Boolean}
 */
export const hasFeatureFlag = (feature_flag, _agency_uid = 0) => {
  const { account = {} } = globalStore;
  const { feature_flag_list = [] } = account;
  const agency_uid = _agency_uid || account.bm_id || account.agency_uid;
  return Boolean((feature_flag_list[agency_uid] || {})[feature_flag]);
};

/**
 * bm 是否有灰度开关
 * @param {*} feature_flag
 * @returns {Boolean}
 */
export const bmHasFeatureFlag = (feature_flag) => {
  const { account = {} } = globalStore;
  const { feature_flag_list = [], bm_id, agency_uid } = account;
  return Boolean((feature_flag_list[bm_id || agency_uid] || {})[feature_flag]);
};

/**
 * @description 一组服务商是否包含灰度开关
 * @param  {} feature_flag
 * @param  {} agency_uid_list
 * @return {Boolean}
 */
export const hasContainFeatureFlag = (feature_flag, agency_uid_list = []) => {
  return agency_uid_list.some((id) => hasFeatureFlag(feature_flag, id));
};

/**
 * @description 主体是否有灰度开关
 * @param  {} feature_flag
 * @return {Boolean}
 */
export const hasFeatureFlagSuper = (feature_flag) => {
  const { account = {} } = globalStore;
  return Boolean(account?.feature_flag?.[feature_flag]);
};

/**
 * @description 是否有角色
 * @param {*} role 角色码
 * @returns {Boolean}
 */
export const hasRole = (role) => {
  const { account = {} } = globalStore;
  return Boolean(account?.role_list?.[role]);
};

/**
 * @description 任意一个角色满足
 * @param {*} roleList 角色码列表
 * @returns {Boolean}
 */
export const hasRoleOneOf = (roleList) => {
  const { account = {} } = globalStore;
  if (!roleList?.length) {
    return true;
  }
  return roleList.some((role) => Boolean(account?.role_list?.[role]));
};

/**
 * @description 是否为免登录
 * @returns {Boolean}
 */
export const isFreeLogin = () => {
  const { account = {} } = globalStore;
  return ![LoginType.qq, LoginType.wx].includes(account.login_type);
};
